export const BANNER_FORMAT_FLAG = 'rm-banner-ads';

export const BANNER_FORMAT_ARMS = [
  'CONTROL',
  'STORY',
  'STORY_ROTATE',
  'ARROWS',
  'ARROWS_ROTATE',
] as const;

export type BannerFormatArm = (typeof BANNER_FORMAT_ARMS)[number];

export type BannerNavigation = 'story' | 'arrows';

export type BannerNavControl = 'tap' | 'swipe' | 'arrow';

export type BannerArrival =
  | 'initial'
  | BannerNavControl
  | 'auto'
  | 'decline'
  | 'claim';

export type BannerExperience =
  | { kind: 'control' }
  | { kind: 'drawer'; navigation: BannerNavigation }
  | { kind: 'inline' };

export const BANNER_HEADLINE = "You've unlocked this gift";

export function isBannerFormatArm(value: unknown): value is BannerFormatArm {
  return BANNER_FORMAT_ARMS.some((arm) => arm === value);
}

export function resolveBannerExperience(
  arm: string,
  visit: number,
): BannerExperience {
  switch (arm) {
    case 'STORY':
      return { kind: 'drawer', navigation: 'story' };
    case 'ARROWS':
    case 'ARROWS_ROTATE':
      return { kind: 'drawer', navigation: 'arrows' };
    case 'STORY_ROTATE':
      return visit % 2 === 0
        ? { kind: 'inline' }
        : { kind: 'drawer', navigation: 'story' };
    default:
      return { kind: 'control' };
  }
}
